import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TemplateMasterService } from '../master_modules/masters/apps/template/template-master.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CategorySelectionTemplateComponent } from '../master_modules/masters/apps/template/templates/popups/category-selection-template/category-selection-template.component';
import { PreviewRightsideTemplateComponent } from '../master_modules/masters/apps/template/templates/popups/preview-rightside-template/preview-rightside-template.component';
import { CreateTemplateComponent } from '../master_modules/masters/apps/template/templates/create-template/create-template.component';
import { Subscription } from 'rxjs';
import { DeleteTemplateComponent } from '../master_modules/masters/apps/template/templates/popups/delete-template/delete-template.component';
import { EventEmmiterService } from '../services/event-emmiter.service';

@Component({
  selector: 'app-v3-templates',
  templateUrl: './v3-templates.component.html',
  styleUrls: ['./v3-templates.component.scss', './v3-templates-dup.component.scss']
})
export class V3TemplatesComponent {

  // ✅ Reference to the ng-template in HTML
  @ViewChild('duplicateDialog') duplicateDialogTemplate!: TemplateRef<any>;

  searchIndustryText: any = '';
  pageLoader: boolean = false;
  industriesList: any = [];
  duplicateInstriesList: any = [];
  selectedIndustry: any;
  pagesList: any = [];
  totalIndustriesCount: any;

  // ✅ Duplicate dialog variables — sab kuch isi component mein
  dupItem: any = null;
  dupSearchText: string = '';
  dupFilteredIndustries: any[] = [];
  dupAllIndustries: any[] = [];
  dupSelectedIndustry: any = null;
  dupTemplateName: string = '';
  dupLoading: boolean = false;
  private dupDialogRef: MatDialogRef<any> | null = null;

  handleKeyboardNavigation(event: KeyboardEvent): void {
    if (!this.duplicateInstriesList || this.duplicateInstriesList.length === 0) return;
    const currentIndex = this.duplicateInstriesList.findIndex(ind => ind.status);
    if (currentIndex === -1) return;
    let newIndex = currentIndex;
    if (event.key === 'ArrowDown') {
      if (currentIndex < this.duplicateInstriesList.length - 1) newIndex = currentIndex + 1;
    } else if (event.key === 'ArrowUp') {
      if (currentIndex > 0) newIndex = currentIndex - 1;
    } else {
      return;
    }
    event.preventDefault();
    this.selectIndustry(this.duplicateInstriesList[newIndex]);
  }

  constructor(
    private router: Router,
    private templateMasterService: TemplateMasterService,
    private _snackbar: MatSnackBar,
    private eventService: EventEmmiterService,
    private dialog: MatDialog,
  ) { }

  title = 'ngSlick';
  totalPages: any[] = [];
  totalPagesCount: any;
  searchParameter: any = '';
  slides: any[] = [];

  slideConfig = {
    slidesToShow: 3, slidesToScroll: 1, dots: false, infinite: false, arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: false, dots: false, fade: true, cssEase: 'linear' } },
      { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  addSlide() { this.slides.push(488); }
  removeSlide() { this.slides.length = this.slides.length - 1; }
  slickInit(e: any) { }
  breakpoint(e: any) { }
  afterChange(e: any) { }
  beforeChange(e: any) { }

  ngOnInit() {
    this.listAllIndustriesWithCount();
    this.refreshList();
    window.addEventListener('keydown', this.handleKeyboardNavigation.bind(this));
    const storedIndustry = localStorage.getItem('selectedIndustry');
    if (storedIndustry) {
      const industry = JSON.parse(storedIndustry);
      this.listAllIndustriesWithCount(industry.id);
      this.getTemplatesById(null);
    } else {
      this.listAllIndustriesWithCount();
    }
  }

  ngOnDestroy() {
    this.previewPageSubscription?.unsubscribe();
    this.createTemplateSubscription?.unsubscribe();
    window.removeEventListener('keydown', this.handleKeyboardNavigation.bind(this));
  }

  searchTemplateName: string = '';
  dataSource: any = [];
  components: any = [];

  searchTemplate() {
    if (this.searchTemplateName.length > 1)
      this.filteredPagesList = this.pagesList.filter((page: any) => {
        if (this.activePagesTab === 'All') return page.name.includes(this.searchTemplateName);
        else return page.name.includes(this.searchTemplateName) && page.approvalStatus === this.activePagesTab;
      });
    else if (this.searchTemplateName.length === 0) {
      if (this.activePagesTab === 'All') this.filteredPagesList = this.pagesList;
      else this.filteredPagesList = this.pagesList.filter(page => page.approvalStatus === this.activePagesTab);
    }
  }

  addTemplate() {
    let openDialog = this.templateMasterService.openDialogWithData(
      CategorySelectionTemplateComponent, 'auto', '25%', { data: 'ADD_TEMPLATE' }
    );
    openDialog.afterClosed().subscribe((res: any) => {
      if (res.data != null) {
        if (res.data.tempGenerated) {
          this.listAllIndustriesWithCount();
        } else {
          let bDetails: any = { type: res.data.websiteType };
          localStorage.setItem('bDetails', JSON.stringify(bDetails));
          this.dialog.closeAll();
          this.router.navigate(['/master/template/create-template'], {
            queryParams: { subIndustryId: res.data.bType.subIndustryId, subIndustryName: res.data.bType.subIndustryName, name: res.data.tempName, edit: false, websiteType: res.data.websiteType, approvalStatus: 'PENDING', desc: res.data.desc }
          });
        }
      }
    });
  }

  // =========================================================
  // ✅ DUPLICATE — sab kuch isi component mein, koi alag file nahi
  // =========================================================
  duplicateComponent(item: any, dialogTemplate: TemplateRef<any>) {
    // Reset state
    this.dupItem = item;
    this.dupTemplateName = (item?.name || 'Untitled Template') + ' (Copy)';
    this.dupSearchText = '';
    this.dupSelectedIndustry = null;
    this.dupLoading = false;

    // Load industries for dropdown
    this.templateMasterService.v3StudioIndustries().subscribe(
      (res: any) => {
        this.dupAllIndustries = res.data || [];
        this.dupFilteredIndustries = [...this.dupAllIndustries];
      },
      () => this._snackbar.open('Failed to load industries', 'Close', { duration: 2000 })
    );

    // Open the ng-template as a dialog — koi alag component nahi
    this.dupDialogRef = this.dialog.open(dialogTemplate, {
      width: '440px',
      maxHeight: '90vh',
      disableClose: false,
    });
  }

  dupFilterIndustries() {
    if (!this.dupSearchText.trim()) {
      this.dupFilteredIndustries = [...this.dupAllIndustries];
    } else {
      this.dupFilteredIndustries = this.dupAllIndustries.filter(ind =>
        ind.name.toLowerCase().includes(this.dupSearchText.toLowerCase())
      );
    }
  }

  dupSelectIndustry(ind: any) {
    this.dupSelectedIndustry = ind;
  }

  confirmDuplicate() {
    if (!this.dupSelectedIndustry || !this.dupTemplateName.trim()) return;
    this.dupLoading = true;

    const payload = {
      sourceTemplateId: this.dupItem?.id,
      subIndustryId: this.dupSelectedIndustry.id,
      subIndustryName: this.dupSelectedIndustry.name,
      name: this.dupTemplateName.trim(),
      approvalStatus: 'PENDING',
      websiteType: this.dupItem?.websiteType || this.dupItem?.type || null,
      description: this.dupItem?.description || this.dupItem?.desc || null,
    };

    this.templateMasterService.v3DuplicateTemplate(payload).subscribe(
      () => {
        this.dupLoading = false;
        this._snackbar.open('Template duplicated successfully!', 'Ok', { duration: 2000 });
        this.dupDialogRef?.close();
        this.listAllIndustriesWithCount(this.selectedIndustry?.id);
      },
      (err: any) => {
        this.dupLoading = false;
        this._snackbar.open(err?.error?.message || 'Duplication failed', 'Close', { duration: 2000 });
      }
    );
  }

  closeDuplicateDialog() {
    this.dupDialogRef?.close();
  }
  // =========================================================

  showAllPages(id) {
    this.router.navigate([`/master/template/all-templates/${id}`]);
  }

  componentSource: any = [];
  gettingLoader: boolean = false;

  updateTabCounts(allPages: any[]) {
    this.templateTab[0].count = allPages.length;
    this.templateTab[1].count = allPages.filter(page => page.approvalStatus === 'APPROVED').length;
    this.templateTab[2].count = allPages.filter(page => page.approvalStatus === 'PENDING').length;
    this.templateTab[3].count = allPages.filter(page => page.approvalStatus === 'INPROGRESS').length;
    this.templateTab[4].count = allPages.filter(page => page.approvalStatus === 'REJECTED').length;
  }

  listAllIndustriesWithCount(selectedIndustryId?: string) {
    this.pageLoader = true;
    this.industriesList = [];
    this.duplicateInstriesList = [];
    this.templateMasterService.v3StudioIndustries().subscribe(
      (res: any) => {
        this.industriesList = res.data.map((element: any) => ({ ...element, status: false }));
        this.duplicateInstriesList = [...this.industriesList];
        this.totalIndustriesCount = this.industriesList.reduce((acc, curr) => acc + (curr.count || 0), 0);
        if (selectedIndustryId) {
          const found = this.duplicateInstriesList.find(x => x.id === selectedIndustryId);
          if (found) {
            found.status = true;
            this.selectedIndustry = found;
            this.getTemplatesById(found.id);
            this.pageLoader = false;
            return;
          }
        }
        if (this.duplicateInstriesList.length > 0) {
          this.duplicateInstriesList[0].status = true;
          this.selectedIndustry = this.duplicateInstriesList[0];
          this.getTemplatesById(this.selectedIndustry.id);
        }
        this.pageLoader = false;
      },
      (err: any) => {
        this.pageLoader = false;
        this._snackbar.open(`${err.error.message}`, 'Close', { duration: 2000 });
      }
    );
  }

  filteredPagesList: any[] = [];

  getTemplatesById(id: any) {
    this.templateMasterService.v3StudioTemplesByIndustryId(id).subscribe(
      (res: any) => {
        this.totalPages = res.data;
        this.pagesList = res.data;
        this.filteredPagesList = [...this.pagesList];
        this.updateTabCounts(this.pagesList);
        this.pageLoader = false;
      },
      (err: any) => {
        this.pageLoader = false;
        this._snackbar.open(err.error.message, 'Close', { duration: 2000 });
      }
    );
  }

  previewPageSubscription?: Subscription;
  createTemplateSubscription?: Subscription;

  showPreviewPage(item) {
    let dialog = this.templateMasterService.openDialogWithData(
      PreviewRightsideTemplateComponent, '100vh', '34%', { pageData: item }
    );
    this.previewPageSubscription?.unsubscribe();
    this.previewPageSubscription = dialog.afterClosed().subscribe((res) => {
      if (res?.id) {
        let bDetails: any = { type: res.data.websiteType };
        localStorage.setItem('bDetails', JSON.stringify(bDetails));
        let templateDialog = this.templateMasterService.openDialogWithData(CreateTemplateComponent, '100vh', '100%', { templateId: res.id, edit: true, subIndustryId: item.subIndustry.id });
        this.createTemplateSubscription?.unsubscribe();
        this.createTemplateSubscription = templateDialog.afterClosed().subscribe(() => this.listAllIndustriesWithCount());
      } else if (res) {
        this.listAllIndustriesWithCount();
      }
    });
  }

  editComponent(item: any) {
    let bDetails: any = { type: item.type };
    localStorage.setItem('bDetails', JSON.stringify(bDetails));
    this.dialog.closeAll();
    this.router.navigate(['/master/template/create-template'], {
      queryParams: { edit: true, id: item.id, subIndustryId: item.subIndustry.id, subIndustryName: item.subIndustry.name, name: item.name }
    });
  }

  viewComponent(item: any) {
    this.router.navigate(['/master/template/create-template'], {
      queryParams: { edit: false, id: item.id || null, preview: true, subIndustryId: item?.subIndustry?.id, subIndustryName: item?.subIndustry?.name, name: item.name }
    });
  }

  deleteComponent(item: any) {
    let dialog = this.templateMasterService.openDeleteDialog(
      DeleteTemplateComponent, '230px', '350px', { data: item }, '80vw'
    );
    dialog.afterClosed().subscribe(() => this.listAllIndustriesWithCount());
  }

  totalCount: any;

  selectIndustry(item: any) {
    this.pagesList = [];
    this.duplicateInstriesList.forEach(element => {
      if ((element.name.split(' ').join('_')).toLowerCase() === (item.name.split(' ').join('_')).toLowerCase()) {
        element.status = true;
        this.selectedIndustry = element;
        this.getTemplatesById(element.id);
        localStorage.setItem('selectedIndustry', JSON.stringify(item));
      } else {
        element.status = false;
      }
    });
  }

  searchIndustry() {
    this.duplicateInstriesList = [];
    if (this.searchIndustryText.length != 0) {
      this.industriesList.forEach(item => {
        if (item.name.toLowerCase().includes(this.searchIndustryText.toLowerCase()))
          this.duplicateInstriesList.push(item);
      });
    } else {
      this.duplicateInstriesList = [...this.industriesList].sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      );
    }
  }

  templateTab = [
    { name: 'All Templates', status: true, count: 0 },
    { name: 'Approved Templates', status: false, count: 0 },
    { name: 'Approval Pending', status: false, count: 0 },
    { name: 'Inprogress Templates', status: false, count: 0 },
    { name: 'Rejected Templates', status: false, count: 0 }
  ];

  activePagesTab: string = '';

  setActiveTab(index: number) {
    this.searchTemplateName = '';
    this.templateTab.forEach((tab, i) => tab.status = i === index);
    const allPages = this.totalPages || [];
    switch (this.templateTab[index].name) {
      case 'All Templates': this.filteredPagesList = allPages; this.activePagesTab = 'All'; break;
      case 'Approved Templates': this.filteredPagesList = allPages.filter(p => p.approvalStatus === 'APPROVED'); this.activePagesTab = 'APPROVED'; break;
      case 'Approval Pending': this.filteredPagesList = allPages.filter(p => p.approvalStatus === 'PENDING'); this.activePagesTab = 'PENDING'; break;
      case 'Rejected Templates': this.filteredPagesList = allPages.filter(p => p.approvalStatus === 'REJECTED'); this.activePagesTab = 'REJECTED'; break;
      case 'Inprogress Templates': this.filteredPagesList = allPages.filter(p => p.approvalStatus === 'INPROGRESS'); this.activePagesTab = 'INPROGRESS'; break;
      default: this.filteredPagesList = allPages;
    }
    this.filteredPagesList.forEach(p => p.templateName = p.name);
    this.eventService.updateTitle.emit({ count: `${this.filteredPagesList.length} Pages` });
  }

  closeEvent: any;

  refreshList() {
    this.closeEvent = this.eventService.updateTemplateStatus.subscribe(
      (res: any) => {
        if (res.view) {
          setTimeout(() => {
            if (res.subIndustryId) this.listAllIndustriesWithCount(res.subIndustryId);
            else this.listAllIndustriesWithCount();
          }, 500);
          this.templateTab.forEach(tab => tab.name === 'All Templates' ? tab.status = true : tab.status = false);
        }
      }
    );
  }

  getNoTemplatesMessage(): string {
    const activeTab = this.templateTab.find(tab => tab.status);
    if (!activeTab) return 'No Templates Found';
    switch (activeTab.name) {
      case 'All Templates': return 'No Templates Found';
      case 'Approved Templates': return 'No Approved Templates';
      case 'Approval Pending': return 'No Pending Templates';
      case 'Rejected Templates': return 'No Rejected Templates';
      default: return 'No Templates Found';
    }
  }
}